<template>
  <form-group
    class="attachment-input"
    :label="label"
    :errors="internalErrors"
    @focus="focus"
  >
    <attachment-picker
      ref="picker"
      :attachment-type="attachmentType"
      :multiple="false"
      @select="selectAttachment"
    />

    <div
      v-if="internalValue"
      class="attachment-input__preview uk-margin-small-bottom"
    >
      <thumbnail
        v-if="internalValue.thumbImageUrl"
        :attachment="internalValue"
        class="uk-margin-small-bottom"
      />
      <a v-else :href="internalValue.url">
        {{internalValue.name || internalValue.url}}
      </a>
    </div>

    <file-upload-button
      ref="uploadButton"
      :attachment-type="attachmentType"
      @upload="selectUploadedAttachment"
      :disabled="disabled"
    />
    <common-button
      icon="album"
      :text="$t('actions.select')"
      @click="$refs.picker.show()"
      :disabled="disabled"
    />
    <common-button
      v-if="internalValue"
      icon="close"
      :text="$t('actions.remove')"
      @click="removeAttachment"
      :disabled="disabled"
    />
  </form-group>
</template>

<script>
import AttachmentPicker from '@/components/AttachmentPicker';
import CommonButton from '@/components/CommonButton';
import FileUploadButton from '@/components/FileUploadButton';
import Input from '@/mixins/Input';
import Thumbnail from '@/components/Thumbnail';

export default {
  name: 'attachment-input',
  mixins: [Input],
  components: {
    AttachmentPicker,
    CommonButton,
    FileUploadButton,
    Thumbnail,
  },
  props: {
    value: Object,
    attachmentType: String,
  },
  methods: {
    onInput(value) {
      this.clearErrors();
      this.$emit('input', value);
      this.$emit('change', value);
    },
    selectAttachment(attachments) {
      // TODO: What happens if multiple attachments have been selected?
      this.onInput(attachments[0]);
    },
    selectUploadedAttachment({ attachments }) {
      this.onInput(attachments[0]);
    },
    removeAttachment() {
      this.onInput(null);
    },
    focus() {
      this.$refs.uploadButton.click();
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          remove: 'Entfernen',
          select: 'Auswählen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// AttachmentInput.vue?110db5e5